export { default as DataTableV2 } from "./DataTableV2";
export { default as createColumnV2 } from "./createColumnV2";


// WEBPACK FOOTER //
// ./src/components/common/DataTableV2/index.js